import { getListPage } from '@/services/join';
import { useRequest } from '@umijs/max';
import { useEffect } from 'react';

export default function useHome() {
  const { data: xyzpJoinData, loading: xyzploading, error: xyzperror, run: xyzpRun } = useRequest(getListPage, {
    manual: true,
  });
  const { data: shzpJoinData, loading: shzploading, error: shzperror, run: shzpRun } = useRequest(getListPage, {
    manual: true,
  });

  useEffect(() => {
    xyzpRun({ currentPage: 1, pageSize: 500, type: 2, siteId: 'ST-20241124222158' });
    shzpRun({ currentPage: 1, pageSize: 500, type: 1, siteId: 'ST-20241124222158' });
  }, [])

  return {
    xyzpJoinData: xyzpJoinData?.resData?.result,
    shzpJoinData: shzpJoinData?.resData?.result,
  };
}
